import { FeatureDisabled } from 'Shared/backend/features/FeatureDisabled';
import { useVenue } from 'Shared/VenueProvider';
import { JSX, Show } from 'solid-js';


export function MenusGate(P:{children:JSX.Element})
{
	return (
		<Show when={useVenue().settings.general.enableMenus} fallback={<FeatureDisabled feature='Menus' />}>
			{P.children}
		</Show>
	);
}

export function SpecialsGate(P:{children:JSX.Element})
{
	return (
		<Show when={useVenue().settings.general.enableSpecials} fallback={<FeatureDisabled feature='Specials' />}>
			{P.children}
		</Show>
	);
}

export function EventsGate(P:{children:JSX.Element})
{
	return (
		<Show when={useVenue().settings.general.enableEvents} fallback={<FeatureDisabled feature='Events' />}>
			{P.children}
		</Show>
	);
}

export function StaffResourcesGate(P:{children:JSX.Element})
{
	return (
		<Show when={useVenue().settings.general.enableStaffResources} fallback={<FeatureDisabled feature='Staff resources' />}>
			{P.children}
		</Show>
	);
}
